import React from "react";
import SideMenu from "../pages/dashboard/components/SideMenu";
import AppNavbar from "../pages/dashboard/components/AppNavbar";
import { Box, Stack } from "@mui/material";
import Header from "../pages/dashboard/components/Header";
import { alpha } from "@mui/material/styles";

const DashboardLayout = ({ children }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <SideMenu />
      <AppNavbar />
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: "auto",
        })}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: "center",
            mx: 3,
            pb: 5,
            mt: { xs: 8, md: 0 },
          }}
        >
          <Header />
          {children}
        </Stack>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
